import { onMounted, onUnmounted } from 'vue';

/**
 * Composable to handle Escape key press for closing modals/dialogs.
 * Automatically adds and removes the event listener on mount/unmount.
 *
 * @param callback - Function to call when Escape is pressed
 * @param enabled - Optional ref or getter to conditionally enable/disable the handler
 */
export function useEscapeKey(callback: () => void, enabled: () => boolean = () => true) {
  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && enabled()) {
      callback();
    }
  }

  onMounted(() => {
    document.addEventListener('keydown', handleKeyDown);
  });

  onUnmounted(() => {
    document.removeEventListener('keydown', handleKeyDown);
  });
}
